import React from "react";
import { Box } from "@mui/material";
import AnimatedFlower from "./components/AnimatedFlower/AnimatedFlower";
import Countdown from "./components/Countdown";
import name_logo from "../../assets/img/name_logo.png";

const Home: React.FC = () => {
    return (
        <Box
            sx={{
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',   // 👈 centre l’ensemble
                height: { xs: '80vh', sm: '100vh', md: '100vh', lg : '75vh', xl: '85vh' },
                width: '100%',
                overflow: 'hidden',
                gap: { xs: 1, sm: 1, md : 1, xl:3 },      // 👈 espace maîtrisé
            }}
        >
            {/* Fleur + logo */}
            <Box
                sx={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                }}
            >
                <AnimatedFlower />

                <Box
                    component="img"
                    src={name_logo}
                    alt="logo"
                    sx={{
                        position: 'absolute',
                        height: { xs: '23vh', sm: '26vh', md: '30vh', lg:'34vh' }, // 👈 lié au viewport
                        maxHeight: 500,
                        zIndex: 2,
                    }}
                />
            </Box>

            {/* Countdown collé sous la fleur */}
            <Box
            >
                <Countdown targetDate="2026-07-11" />
            </Box>
        </Box>


    );
};

export default Home;

